import axios from 'axios';
import React, { useEffect, useState } from 'react'
import TableLoader from './TableLoader';
import { BeatLoader } from 'react-spinners';
import { useLocation, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import GlobalFooter from './GlobalFooter';

function SelectAccount() {
    const token = localStorage.getItem('token')
    const phone = localStorage.getItem('phone')
    const record = JSON.parse(localStorage.getItem("auth"))
    const location = useLocation();
    const navigate = useNavigate();
    const {pathname} = location;
    

    const [selectedBank, setSelectedBank] = useState(null);
    const [selectBtn, setSelectBtn] = useState(null);
    const [accountList,setAccountList] = useState([])
    const [initiatTansferData,setInitiateTransferData] = useState(null);
    const [isBankListLoading,setIsBankListLoading] = useState(false);
    const [isAmount, setIsAmount] = useState(false);
    const [isConfirmTransfer, setIsConfirmTransfer] = useState(false);
    const [isLoading,setIsLoading] = useState(false)
    const [accessToken,setAccessToken] = useState('')

    const handleBankChange = (event) => {
        setSelectBtn(event.target.value);
        // setIsAmount(true);
    
      };

      useEffect(()=>{
        getBankList();
      },[])
    
      
    
      const getBankList = async()=>{
        
        setIsBankListLoading(true)
        try{
          // const result = {
          //   "bvn":"22346162884",
          //   // "bvn":"22257905523",
          // }
          if(pathname === "/pages/select-account"){

            const payload ={
                phoneNumber:phone
            }
            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/ui-data-params"

            const res = await axios.post(url,payload)
            setIsBankListLoading(false)
            const {accounts,
                access_token
                } = res.data
           
            setAccountList(accounts);
            setAccessToken(access_token)

          }else{

              const result = {
                phoneNumber:phone,
                publicToken:token
              }
              const url ="https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/account-list"
              let res = await axios.post(url,{...result}) 
              setIsBankListLoading(false)
             
              const {accounts,access_token} = res.data
              setAccountList(accounts);
              setAccessToken(access_token)
          }
          
        
    
          // Synchronously map over the bankList to update the AccountDesignationName
        
          // setBankList(updatedBankList);
        }catch(err){
          setIsBankListLoading(false)
          const errorMessage = err.response?.data?.message || "An Unexpected error has occured: try again"
          toast.error(errorMessage)
        }
      }

      const handleSubmit = async ()=>{
        setIsLoading(true)
        try{

            // console.log("selectedbank: ",selectedBank)

            const url = "https://1mgy6330f9.execute-api.us-east-2.amazonaws.com/production/initiate-payment"

            const payload ={
                access_token: accessToken,
                account_id:selectedBank.account_id,
                amount:`${record?.data?.amount}`,
                legal_name: selectedBank.official_name
            }
            const res  = await axios.post(url,payload)
            console.log("response: ",res.data)
            const data = res.data
            setIsLoading(false)
            navigate('/pages/payment-confirmation',{state:{data}})
            setIsLoading(false)

        }catch(err){
            setIsLoading(false)
            console.log(err)
            const errorMessage = err.response?.data?.message || "An Unexpected error has occured: try again"
            toast.error(errorMessage)
        }
      }
      const handleClose = ()=>{
        navigate('/pages/global-payment')
      }
  return (
    <div className='global_layout'>
        
           
    
    <div className='global_container'>
            <div className='top_bar'>
              
                <img src='/images/global/close.svg' alt='' onClick={handleClose} style={{marginLeft:"auto"}}/>
            </div>

            <div className='global_content'>
                <img style={{width:"54px",height:"60px"}} src='/images/global/account.gif' alt='' />
                <p className='glob_title'>Select accounts</p>
                <p className='glob_desc'>You’ll share all accounts from your selected institution.</p>
                
                
                {/* Phone Number */}
                <div className={`glob_form${accountList?.length >4 ? "scroll_bar":""}`} style={{marginTop:"20px",display:"flex",flexDirection:"column",gap:"10px"}}>
                    {/* first part */}
                    {
                        accountList?.map((bank,index)=>(

                        <div className="account-type" 
                        onClick={() => setSelectedBank(bank)} 
                        style={{height:"56px",border: selectedBank?.account_id === bank.account_id && "1px solid #259792"}}
                        
                        >

                            <div className="account-type-text" style={{display:"flex", flexDirection:"row",alignItems:"center"}}>
                                <div>
                                    <img style={{width:"24px",height:"24px"}} src='/images/global/bank.svg' alt="logo"/>
                                </div>
                                <div style={{display:"flex",flexDirection:"column",alignItems:"flex-start"}}>
                                    <p className="account-number">{bank.name}</p>
                                    <p className="type-of-account">{bank.official_name}</p>
                                </div>
                            </div>

                            <input
                            type="radio"
                            name="options"
                            value={bank.account_id}
                            checked={selectedBank?.account_id === bank.account_id}
                            onChange={() => setSelectedBank(bank)}
                            className="custom-radio"
                            />
                        </div>
                        ))
                    }
                    

                   

                </div>
                <button 
                     disabled={!selectedBank || isLoading}
                     className={`${!selectedBank || isLoading ? 'unactive' : 'globalBtn'}`}
                   
                    style={{width:"100%",display:"flex",alignItems:"center",justifyContent:"center",marginTop:"18px",gap:"8px"}}
                    onClick={handleSubmit}
                    >
                        {isLoading ? (
                            <BeatLoader
                                color="#FFF"
                                cssOverride={{}}
                            />              ) : (
                            <>   
                                <p>Confirm</p>
                                {
                                    !selectedBank || isLoading ?
                                    <img src='/images/global/inactive.svg' alt='' />:
                                    <img src='/images/global/activeArrow.svg' alt='' />
                                }
                            </>
                        )}   
                    </button>
               
                <div className='resend_code'>
                    <img src='/images/global/plus.svg' alt=''/>
                    <p className='add_text'>Add new account</p>
                </div>

            </div>
        </div>
        {
        isBankListLoading && <TableLoader />
      }
      {
            !record?.total_whitelabelling &&
            <GlobalFooter />
        }
    </div>
  )
}

export default SelectAccount